var _style, _path, _circle, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComments05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 17.2 15.8",
    style: {
      enableBackground: "new 0 0 17.2 15.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00A850;}\n\t.st1{fill:#E84D4E;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{font-family:'MyriadPro-Regular';}\n\t.st4{font-size:9.3813px;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.9,14.5c0.3,0.3,0.2,0.8-0.1,1c-0.1,0.1-0.3,0.2-0.5,0.2H9.7c-2.2,0-4.2-0.9-5.7-2.5h3.5 c4.5-0.1,8.1-3.1,8.3-6.9c0.9,1,1.3,2.2,1.3,3.5v0.4c-0.1,1.2-0.6,2.2-1.4,3.1l-0.1,0.1L16.9,14.5L16.9,14.5 M14.5,6.1 c0,3.3-3.2,5.8-7,5.9H0.8C0.4,12,0,11.6,0,11.2c0-0.2,0.1-0.4,0.2-0.5l0.1-0.1l1.2-1.1H1.4C0.6,8.7,0.2,7.6,0.1,6.4V6.1 C0,2.8,3.3,0.2,7.3,0.2S14.5,2.8,14.5,6.1z M9,7.3c0-0.4-0.3-0.7-0.7-0.7l0,0H3.7C3.3,6.7,3.1,7.1,3.2,7.5C3.3,7.8,3.5,7.9,3.8,8 h4.6C8.7,8,9,7.7,9,7.3z M11,5.3c0-0.4-0.3-0.7-0.8-0.7H3.7C3.3,4.6,3,4.9,3,5.3l0,0C3,5.7,3.3,6,3.8,6h6.6C10.7,6.1,11,5.7,11,5.3 L11,5.3z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 13.3,
    cy: 3.9,
    r: 3.9
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 10.8942 6.9488)",
    className: "st2 st3 st4"
  }, "5")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComments05);
export default __webpack_public_path__ + "static/media/Comments-05.9010557cd3c34e7dc8f80310a0b0ae53.svg";
export { ForwardRef as ReactComponent };